const PREFIX = 'orders';

export const ORDER_URLS = {
  GET_ORDER: PREFIX,
  CREATE_ORDER: PREFIX,
  GET_ORDER_ACTIVITY: (orderId: string) => `${PREFIX}/${orderId}/activities`,
  ORDERS_STATISTICS: `${PREFIX}/statistics`,
  GET_ORDER_BY_ID: (id: string) => `${PREFIX}/${id}`,
  CANCEL_ORDER: (orderId: string) => `${PREFIX}/${orderId}/cancel`,
  SIGNING_METHODS: 'providers/signing',
  SEND_REMINDER: (id: string) => `${PREFIX}/${id}/reminder`,
  ORDER_STATUS_DETAILS: (orderId: string) => `${PREFIX}/${orderId}/status`,
};
